import { styled } from "../../styles/stitches.config";

export const MenuLayout = styled("div", {
  $reset: "",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  padding: "0.5rem",
});
